import { render, staticRenderFns } from "./detailIndex.vue?vue&type=template&id=185e177a&scoped=true"
import script from "./detailIndex.vue?vue&type=script&lang=js"
export * from "./detailIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e177a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185e177a')) {
      api.createRecord('185e177a', component.options)
    } else {
      api.reload('185e177a', component.options)
    }
    module.hot.accept("./detailIndex.vue?vue&type=template&id=185e177a&scoped=true", function () {
      api.rerender('185e177a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataCenter/waybillMonitoring/detailIndex.vue"
export default component.exports